import { ComponentChild, h } from 'preact'
import { HintContent, ShowMore } from '../../types'
import { Foldable } from '../FoldableView'
import { HintElementView } from '../HintElementView'
import { ShowMoreView } from '../ShowMoreView'

export const HintContentListView = (props: {
  idPrefix: string
  contents: HintContent[]
}) => {
  type ReduceState = [elements: ComponentChild[], skipped: boolean]

  return (
    <div>
      {props.contents.reduce(
        (prev, curr, i, arr) => {
          const key = `${props.idPrefix}__${i}`
          const [prevChildren, skipped] = prev

          // Already broken by ShowMore
          if (skipped) {
            return prev
          }

          // Show more breaks the map,
          // and creates a new Accordion.
          if (curr.type === 'showMore') {
            if (i === arr.length - 1) {
              // ShowMore is place at the last position!
              return prev
            }

            const rest = arr.slice(i + 1)
            const nextElem = (
              <ShowMoreView
                labelToOpen={curr.labelToOpen}
                labelToClose={curr.labelToClose}
              >
                <HintContentListView idPrefix={key} contents={rest} />
              </ShowMoreView>
            )
            const next: ReduceState = [[...prevChildren, nextElem], true]
            return next
          }

          // If current content is not "ShowMore",
          // continue rendering
          const next: ReduceState = [
            [
              ...prevChildren,
              <HintContentView key={key} id={key} content={curr} />,
            ],
            false,
          ]
          return next
        },

        // Initial val: [No element, not skipped]
        [[], false] as ReduceState
      )}
    </div>
  )
}

const HintContentView = (props: {
  content: Exclude<HintContent, ShowMore>
  id: string
}) => {
  const ct = props.content

  switch (ct.type) {
    case 'foldable': {
      return (
        <div>
          <Foldable label={ct.label}>
            <HintContentListView idPrefix={props.id} contents={ct.contents} />
          </Foldable>
        </div>
      )
    }

    case 'text':
    case 'image': {
      return (
        <div>
          <HintElementView elem={ct} />
        </div>
      )
    }

    default: {
      return <div>{JSON.stringify(ct)}</div>
    }
  }
}
